/* global axios */
import ApiClient from './ApiClient';

// AGENTS-LINK-01 (L-11): o passe com que um membro da conta entra no link de teste. Fora de
// `accounts`, porque a conta vem do link.
class TestLinkPassesAPI extends ApiClient {
  constructor() {
    super('test_link_passes', { accountScoped: false });
  }

  // Devolve `{ passe, url }`: `url` é a página do link com o passe no fragmento.
  pedir(token) {
    return axios.post(this.url, { token }).then(r => r.data);
  }
}

export default new TestLinkPassesAPI();
